/** @module csi/view/ToolbarQuickSearch */
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPlugin",
	"./QuickSearch",
], function(lang, Action, PluginFactory, ToolbarPlugin, QuickSearch) {

	return PluginFactory.declare("quickSearch", [QuickSearch, ToolbarPlugin], {
		bKeepViewEnabled: true,

		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ViewQuery",
			});
		},

		/**
		 * Associate MultiFilter with view toolbar
		 */
		postCreate: function() {
			this.set("view", this.getView());
			this.inherited(arguments);
		},

		/**
		 * Do not instantiate plugin when printing
		 */
		validatePlugin: function(ctx) {
			const view = ctx.view;
			return !ctx.bPrint && view.allowsSelections() && !view.bDisableQuickSearch;
		},

	});
});